import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class TempAttribute extends Sensor {
  public tempChart: any;
  private tempSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.tempChart = null;
    this.tempSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.tempSensor, position);
      this.tempSensor[position].push([timestamp, element.temp]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredTemp = this.tempSensor.filter(series => series.length > 0);

    const positionNodeTemp = this.tempSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.tempChart = this.getConfigChar(
      'temp',
      this.getChartSeriesNewNode('Sensor', filteredTemp, positionNodeTemp),
      this.getRanges('temp'),
      this.getLimits('temp')
    );
  }

  public hasTempSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.tempSensor.length &&
      this.tempSensor[index].length > 0
    );
  }

  public getTempSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.tempSensor.length) {
      const sensorData = this.tempSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura', value: 'temp' }
    ];
  }
}
